//CPR
export interface ZipParams {
    date: string | number;
    fileList?: File[];
}

export interface CprParams {
    blob: Blob;
    filename?: string;
    attachments?: File[];
}

export enum dateTypes {
    ALL = 'all',
    TODAY = 'today',
}

export interface ISendProblemReportParamsToCpr {
    id: string;
    tokenType: string;
    cprUri: string;
    token: string;
    date: string | number;
}
